import { render, staticRenderFns } from "./SveiConfigurazionePuntiIncontroDistrettiComponent.vue?vue&type=template&id=1a878c05"
import script from "./SveiConfigurazionePuntiIncontroDistrettiComponent.vue?vue&type=script&lang=js"
export * from "./SveiConfigurazionePuntiIncontroDistrettiComponent.vue?vue&type=script&lang=js"
import style0 from "./SveiConfigurazionePuntiIncontroDistrettiComponent.vue?vue&type=style&index=0&id=1a878c05&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports